import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { useParams, useHistory, Link } from "react-router-dom";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { ROLENAME, saleLostApprovalHeader, designLostApprovalHeader } from '../utils';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import { Modal } from 'antd';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import HttpService from '../services/httpService';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Checkbox from '@material-ui/core/Checkbox';
import { commaSeparateAmount } from './commaSeparate';
import { DownloadOutlined, EyeFilled } from '@ant-design/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';


const useStyles = makeStyles((theme) => ({
    table: {
        width: '80vw',
        textAlign: 'center'
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ccc",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function LostLeadApprovalView(props) {
    const classes = useStyles()
    const { userDetails } = useSelector(state => state.user);
    const history = useHistory();
    const [lostApprovalLeads, setLostApprovalLeads] = useState([]);
    const [remarks, setRemarks] = useState('');
    const [openDialogapprove, setOpenDialogapprove] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [rowLeadId, setRowLeadId] = useState('');
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [lostAttachmentFile, setLostAttachmentFile] = useState('');
    const [isChecked,setIsChecked] = useState(false);
    const [asmApproval, setAsmApproval] = useState('');
    const [commonExpCenter, setExpCenter] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [row,setRow] = useState()

    useEffect(() => {
        getAllApprovedLeads();
        expCenters();
    }, [])

    const getAllApprovedLeads = async (selectedExpCenter) => {
        props.setLoading(true)
        try {
            const response = await HttpService.getLostLeadRequests()
            if (response.data == "No leads found.") {
                setLostApprovalLeads([])
            } else {
                arrayUpdateFunction(response.data, selectedExpCenter)
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    //  Show Data according experience and role
    const arrayUpdateFunction = (masterArray, selectedExpCenter) => {
        let expCenterData = selectedExpCenter?.map((el) => el._id);
        const newArr = masterArray.filter((row) => {
            if (expCenterData?.length > 0) {
                return expCenterData.includes(row.experienceCenterId);
            }
            return userDetails?.experienceCenterId?.includes(row.experienceCenterId);
        });
        setLostApprovalLeads(newArr);
    };
    
    const handleApprove = async (v) => {
        props.setLoading(true);
        try {
            setRow(v);
            setRowLeadId(v?._id);
            setOpenDialogapprove(true);
            setAsmApproval(v?.salesLostApproval?.asmApproval)
        } catch (error) {
            console.log("error", error);
        }
        props.setLoading(false);
    }
    const handleReject = async (v) => {
        setRowLeadId(v?._id);
        setOpenDialog(true);
    }

    const handleMultipleExpData = (event, newValue) => {
        setSelectedExperienceCenter(newValue)
        getAllApprovedLeads(newValue)
    }
    // Handle Approve Button of Lost
    const handleApproveWithRemarks = async (row, status) => {
        // let projectId = rowLeadId
        props.setLoading(true);
        try {
            let obj = {
                projectId : rowLeadId,
                status : status,
                remarks : remarks,
                asmLostAttachment: lostAttachmentFile
            }
            if(row?.raiseRefundLostSent){
                await HttpService.approveRefundLeadLostStatus(obj,rowLeadId);
            } else {
                await HttpService.approveLostLead(obj);
            } 
            props.setSnackInfo("Lost Approval Approved","success");
            setOpenDialogapprove(false);
            getAllApprovedLeads();
            setIsChecked(false);
            setRemarks('');
            setLostAttachmentFile('');
            setIsFileUploaded(false);
        } catch (error) {
            console.log("error", error);
        }
        props.setLoading(false);
    }

    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }
    // Handle reject Button of Lost
    const handleRejectWithRemarks = async (row, status) => {
        props.setLoading(true);
        try {
            const obj = {
                projectId: rowLeadId,
                status: status,
                remarks: remarks,
            }
            if(row?.raiseRefundLostSent){
                await HttpService.approveRefundLeadLostStatus(obj,rowLeadId);
            } else {
                await HttpService.approveLostLead(obj);
            }       
            props.setSnackInfo("Lost Request Rejected","success");
            setOpenDialog(false);
            getAllApprovedLeads();
        } catch (error) {
            console.log("error", error);
        }
        props.setLoading(false);
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    }
    const handleCloseDialogApprove = () => {
        setOpenDialogapprove(false);
    }

    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    }

    const handleUploadFile = async(e)=>{
        props.setLoading(true)
        try{
            const fd = new FormData();
            fd.append('file', e.target.files[0]);
            const res = await HttpService.uploadFile(fd);
            setLostAttachmentFile(res.data);
            setIsFileUploaded(true);
        }
        catch(err){
            props.setSnackInfo("Something went wrong","error");
        }
        props.setLoading(false);
    }

    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                <h3 style={{ textAlign: 'center' }}>
                    {/* For Shomil role = Center Head */}
                    {userDetails.roles.find(role => role.name === ROLENAME.CenterHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.AGMSales) && saleLostApprovalHeader} 
                    {/* For DK role for Admin */}
                    {userDetails.roles.find(role => role.name === ROLENAME.Admin || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.DGM_Design) && designLostApprovalHeader}
                </h3>
            </div>
            <Divider />

            {userDetails?.roles && userDetails.roles.some(role => [ROLENAME.DGM_Sales, ROLENAME.SalesHead].includes(role.name)) && (
                <div style={{ display: 'flex' }}>
                    <FormControl style={{ width: '30%', marginTop: '0.4rem' }}>
                        <Autocomplete
                            multiple
                            value={selectedExperienceCenter}
                            onChange={handleMultipleExpData}
                            options={commonExpCenter}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Exp-Center"
                                    variant="outlined"
                                />
                            )}
                        />
                    </FormControl>
                </div>
            )}

            <Paper style={{ marginTop: 20}}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#333', color: '#fff' }}>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Sl No.</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Customer Name</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Project No.</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lead No.</TableCell>
                                {userDetails.roles.find(role => role.name !== ROLENAME.Admin) && (
                                    <>
                                        <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>CHM Design Kick-off Rejection Remarks</TableCell>
                                    </>
                                )}
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lost Reason</TableCell>
                                {/* <TableCell>Lost Request User</TableCell> */}
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Assigned To</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lead Value</TableCell>
                               {userDetails.roles.find(role=> role.name === 'Sales Manager') && <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Attachment/Recording</TableCell>}
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {lostApprovalLeads?.length > 0 ?
                                lostApprovalLeads.sort((a, b) => b.createdAt.split('-').reverse().join().localeCompare(a.createdAt.split('-').reverse().join())).map((row, i) => {
                                    return (
                                        <TableRow key={i + 1}>
                                            <TableCell component="th">{i + 1}</TableCell>
                                            <TableCell component="th" scope="row"> {row?.customerId?.name} </TableCell>
                                            <TableCell component="th" scope="row"> {row?.erpProjectNo} </TableCell>
                                            <TableCell component="th">
                                                <Link to={`/project-logs/${row?._id}`} style={{ color: "#000", textDecoration: 'underline' }}>{row?.lead_no || "N/A"}</Link>
                                            </TableCell>
                                            {/* <TableCell component="th">{moment(row?.createdAt).format('DD-MM-YYYY')}</TableCell> */}
                                            {userDetails.roles.find(role => role.name !== ROLENAME.Admin) && (
                                                <>
                                                    <TableCell component="th">{row?.chmReasonForDesignKickOffRejection || 'NA'}</TableCell>
                                                </>
                                            )}

                                            <TableCell component="th">{row?.reasonForLost}</TableCell>
                                            {/* <TableCell component="th">{row?.lostRaiseUser ? row?.lostRaiseUser : 'NA' }</TableCell> */}
                                            <TableCell component="th">{row?.assignTo ? row?.assignTo?.name : 'NA'}</TableCell>
                                            <TableCell component="th">₹ {commaSeparateAmount(row?.grandTotal) || 'NA'}</TableCell>
                                            { userDetails.roles.find(role=> role.name === 'Sales Manager')  && 
                                             <TableCell component="th" style={{ textAlign: 'center' }}>
                                                { row?.asmLostAttachment ?
                                                        <DownloadOutlined
                                                            onClick={() => window.open(row?.asmLostAttachment)}
                                                            style={{
                                                                color: "green",
                                                                cursor: "pointer",
                                                                fontWeight: "bold",
                                                                fontSize: '24px',
                                                            }}
                                                        />
                                                    : 'NA'
                                                }
                                                </TableCell>
                                            }
                                            {/* Lost Approval Approved dialog */}
                                            <TableCell component="th" >
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Button
                                                        variant="contained"
                                                        color="primary"
                                                        style={{ marginRight: '10px' }}
                                                        onClick={() => handleApprove(row)}
                                                        >
                                                        Approve
                                                        </Button>
                                                        <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleReject(row)}
                                                        >
                                                        Reject
                                                        </Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                                :
                                <TableRow>
                                    <TableCell colSpan={9} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <Dialog open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle>Enter Remarks</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="remarks"
                            label="Remarks"
                            type="text"
                            fullWidth
                            style={{ width: 400 }}
                            value={remarks}
                            onChange={handleRemarksChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleCloseDialog(row)} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={(e) => handleRejectWithRemarks(row, 'Rejected')} color="primary" variant="outlined">
                            Reject
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openDialogapprove} onClose={handleCloseDialogApprove}>
                    <DialogTitle>Enter Remarks</DialogTitle>
                    <DialogContent>
                        <FormControl>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="remarks"
                                label="Remarks"
                                type="text"
                                fullWidth
                                style={{ width: 400 }}
                                value={remarks}
                                onChange={handleRemarksChange}
                            />
                            {/* upload lost attachment voice */}
                            {userDetails.roles.find(role => role.name === 'Assistant Sales Manager') &&
                                <>
                                    <TextField
                                        accept="*"
                                        id="lostAttachment"
                                        type="file"
                                        onChange={handleUploadFile}
                                        style={{ display: 'none' }}
                                    />
                                    <label htmlFor={`lostAttachment`}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ background: "#716ACA" }}
                                            component="span"
                                        >
                                            Upload Attachement/Recording
                                        </Button>
                                        {isFileUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                                    </label>
                                </>
                            }

                            {userDetails.roles.find(role => role.name === 'Sales Manager') && asmApproval === 'Approved' &&
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        checked={isChecked}
                                        onChange={(e) => setIsChecked(e.target.checked)}
                                        color="primary"
                                        label='Attachment/Recording verified by me'
                                    />
                                    <span>Attachment/Recording verified by me</span>
                                </div>
                            }

                        </FormControl>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleCloseDialogApprove(row)} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={() => handleApproveWithRemarks(row, 'Approved')}
                            color="primary"
                            variant='outlined'
                            disabled={(userDetails.roles.some(role => role.name === 'Assistant Sales Manager') && !isFileUploaded) || (userDetails.roles.some(role => role.name === 'Sales Manager') && !isChecked && asmApproval)}
                        >
                            Approve
                        </Button>
                    </DialogActions>
                </Dialog>
            </Paper>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(LostLeadApprovalView)